import { NgModule } from '@angular/core';
import { AccredibleLocaleDatePipe } from './locale-date.pipe';

@NgModule({
  exports: [AccredibleLocaleDatePipe],
  declarations: [AccredibleLocaleDatePipe],
})
export class AccredibleLocaleDatePipeModule {}
